export type PeopleUnlockDataType = 'email' | 'phone';

export interface SharedPeopleUnlock {
  data_type: PeopleUnlockDataType;
  unlocked_by: string;
}

export interface PeopleUnlockCreditMetadata {
  success?: boolean;
  credits_charged?: number;
  people_credits_remaining?: number;
  shared_unlock?: SharedPeopleUnlock;
}

export interface PeopleContactUnlockState {
  email_unlocked?: boolean;
  phone_unlocked?: boolean;
  work_email?: string | null;
  phone_numbers?: string[] | null;
}

export const isPeopleEmailUnlocked = (person?: PeopleContactUnlockState | null): boolean => {
  if (person?.email_unlocked !== undefined) return person.email_unlocked;

  return Boolean(
    person?.work_email && person.work_email !== '-' && !person.work_email.includes('*'),
  );
};

export const isPeoplePhoneUnlocked = (person?: PeopleContactUnlockState | null): boolean => {
  if (person?.phone_unlocked !== undefined) return person.phone_unlocked;
  return Boolean(person?.phone_numbers?.length);
};

export const getSharedUnlockMessage = (
  response?: PeopleUnlockCreditMetadata | null,
): string | null => {
  const sharedUnlock = response?.shared_unlock;
  const unlockedBy = sharedUnlock?.unlocked_by?.trim();
  if (response?.success === false || !sharedUnlock || !unlockedBy) return null;

  const label = sharedUnlock.data_type === 'phone' ? 'Phone number' : 'Email';
  return `${label} already unlocked by ${unlockedBy}. No credits were used.`;
};

export const getPeopleCreditsAfterUnlock = (
  response: PeopleUnlockCreditMetadata,
  currentCredits: number,
  fallbackCost: number,
): number =>
  response.people_credits_remaining ?? currentCredits - (response.credits_charged ?? fallbackCost);
